<div class="d-flex color-container">
  <div *ngFor="let color of colors; index as i" class="color-box" [style.background-color]="color"></div>
</div>
